import React from 'react';
import { Table } from 'antd';

const LineItemStateList = ({ list, columns }) => (
  <Table
    pagination={false}
    rowKey={record => (record.type === 'dma' ? record.dma_id : record.state_code)}
    dataSource={list}
    columns={columns}
  />
);

LineItemStateList.defaultProps = {};

LineItemStateList.propTypes = {};

export default LineItemStateList;
